import { Component, ElementRef, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { GridApi, CellEditingStoppedEvent, ValueFormatterParams, ColDef, ICellRendererParams, ValueGetterParams } from 'ag-grid-community';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { IconCellRendererComponent } from '../../icon-cell-renderer/icon-cell-renderer.component';
import { PCESModalComponent } from '../../pces-client-lists/pces-lists-modal/pces-lists-modal.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-pces-details',
  templateUrl: './pces-email-details.component.html',
  styleUrls: ['./pces-email-details.component.scss']
})
export class PcesEmailDetailsComponent implements ICellRendererAngularComp {

  public params: any;
  private gridApi!: GridApi;

  // variable to trigger when to display HTML content after API loads
  showContent: boolean = false

  // initialize UUID
  email_uuid: string = ''
  
  // initialize objects to store details of shipment details
  pces_email_details: any = {}
  emails: Array<{ [key: string]: string | number | object | boolean }> = [];

  editEnabled: boolean = false

  // forms for displaying details
  detailsForm: FormGroup = this.formBuilder.group({
      clientname: '',
      email: '',
    });


  
  // default column definitions
  defaultColDef = {
      sortable: true,
      filter: 'agTextColumnFilter',
      filterParams: {
        caseSensitive: false,
      },
      autoHeight: true,
      cellClass: 'cell-wrap-text',
      resizable: true,
      editable: true
  };

  // headers for the barcodes grid
  emailColumnDefs = [
  { field: 'pces_outgoing_email_uuid', headerName: 'UUID', hide: true},
  {
    headerName: 'Client Name',
    field: 'contact_organization',
    cellStyle: {'font-weight': 'bold'},          
    //cellRenderer: 'agGroupCellRenderer',    // Add Drop Down Detail
    width: 400
  },
  {
    headerName: 'Email', field: 'contact_email',
    width: 350
  },
  { headerName: 'Cheque No', field: 'cheque_no', width: 150 },        
  { headerName: 'Total Amount', field: 'total_amount', width: 150 },      
  {
    headerName: 'Status',
    field: 'status',
    width: 100
  },  
  {
    headerName: 'Delete', cellRenderer: (params: any) => {
      const button = document.createElement('button');
      const icon = document.createElement('i');

      // Add Font Awesome classes to the icon element
      icon.classList.add('fas', 'fa-trash'); 

      // Append the icon to the button
      button.appendChild(icon);
      button.addEventListener('click', () => {
        this.deletePendingEmail(params);
      });
      return button;
    }, editable: false, width: 100,
  },        
  {
    headerName: 'Send', cellRenderer: (params: any) => {
      const button = document.createElement('button');
      const icon = document.createElement('i');

      // Add Font Awesome classes to the icon element
      icon.classList.add('fas', 'fa-envelope'); 

      // Append the icon to the button
      button.appendChild(icon);
      button.addEventListener('click', () => {
        this.sendEmail(params);
      });
      return button;
    }, editable: false, width: 100,
  },                        
]

  agInit(params: any): void {

    // define the targeted shipment list by getting its shipment_list_uuid
    this.params = params;
    this.gridApi = params.api;
    this.email_uuid = params.data.email_uuid

  
    console.log(params)
    console.log(this.email_uuid)

    const pces_email_details_url = `/api/pces_lists/pces_email_details.php?uuid=${this.email_uuid}`;

    // GET request to the contacts API call for specific contact_UUID
    this.http.get<any>(pces_email_details_url).subscribe(response => {

      this.pces_email_details = response.details
      console.log(this.pces_email_details)

      if (response.emails) {
        this.emails = response.emails
        console.log(this.emails)
      }      
      this.checkFormReady();
    })
  }

  // check if API is finished loading -> populate all the different forms using formbuilder
  // and set show content to true at the end to render HTML
  private checkFormReady(): void {

    if (
      this.emails &&
      this.email_uuid
    ) {

      this.detailsForm = this.formBuilder.group({

        clientname: [this.pces_email_details.clientname],
        email: [this.pces_email_details.email],
      })
      this.detailsForm.disable();      
    }

    this.showContent = true;
  }
  
  refresh(params: any): boolean {
    return false;
  }
  constructor(private http: HttpClient, private formBuilder: FormBuilder, private dialog: MatDialog, private router: Router, private elementRef: ElementRef) { }

  // function to allow for cell editing in the grid, POST request is made when cell editing is finished
  onCellEditingStopped(event: CellEditingStoppedEvent) {

    const editedValue = event.value;
    const column = event.column;
    const rowNode = event.node;

    const email_uuid = rowNode.data.email_uuid

    const email_details_url = `/api/pces_lists/pces_client_details.php?table=pces_and_accounting&command=EMAIL_UPDATE`;

    const columnName = column.getColId();

    console.log('Edited Value:', editedValue);
    console.log('Row Data:', rowNode.data);
    console.log('Column Name:', columnName)

    // create POST body of cell edited of column, columnName, and value changed, editedValue
    var postData = {
      [columnName]: editedValue,
      email_uuid: email_uuid,
    }

    console.log('Post Data:', postData);
    console.log('Stringify:', JSON.stringify(postData))

    return this.http.post<any>(email_details_url, postData)
      .subscribe(response => 
      {
        console.log('Post Response: ', response)
      })
  }

  viewPcesEmailDetails() {
    this.router.navigate(['pces_email_details', this.email_uuid],);
  }

  editEmail(): void {
    this.editEnabled = true
    this.detailsForm.enable();
  }

  saveEmail(): void {
    this.editEnabled = false

    // set the form to the default service form's current values
    const formData = this.detailsForm.value;
    formData.email_uuid = this.email_uuid;

    const pces_email_details_url = `/api/pces_lists/pces_email_details.php?uuid=${this.email_uuid}`;
    
    const client_email_url = `/api/pces_lists/pces_client_details.php?command=EMAIL_UPDATE`;

    this.http.post<any>(client_email_url, formData)
      .subscribe(response => {
        console.log('Post Response: ', response)
        // reset the default services form upon successful post
        this.detailsForm.reset()
        // GET request to retrieve the updated list of default services
        this.http.get<any>(pces_email_details_url).subscribe(response => {

          this.pces_email_details = response.details
          console.log(this.pces_email_details)
          
          this.checkFormReady();
          this.router.navigate(['/pces_email_lists']);
        })
      })
  }


  deletePendingEmail(params: any) {
    const dialogConfig = new MatDialogConfig();
    const pces_outgoing_email_uuid = params.data.pces_outgoing_email_uuid;
    const clientname = params.data.contact_organization;

    dialogConfig.width = '10px'; // You can use pixels or other units
    dialogConfig.height = '10px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Delete Pending Email',
        modalMessage: {uuid: params.data.pces_outgoing_email_uuid, client_name: params.data.contact_organization},
      },
    };

    console.log('Dialog Config:', dialogConfig);

    this.dialog.open(PCESModalComponent, dialogConfig);
  }
  
  sendEmail(params: any) {
    const dialogConfig = new MatDialogConfig();
    const pces_outgoing_email_uuid = params.data.pces_outgoing_email_uuid;
    const clientname = params.data.contact_organization;

    dialogConfig.width = '10px'; // You can use pixels or other units
    dialogConfig.height = '10px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Send Email',
        modalMessage: {uuid: params.data.pces_outgoing_email_uuid, client_name: params.data.contact_organization},
      },
    };

    console.log('Dialog Config:', dialogConfig);

    this.dialog.open(PCESModalComponent, dialogConfig);
  }  
  
  deleteEmail() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '10px'; // You can use pixels or other units
    dialogConfig.height = '10px';
    const email_uuid = this.email_uuid;
    const clientname = this.pces_email_details.clientname;

    dialogConfig.data = {
      data: {
        modalTitle: 'Delete Email',
        modalMessage: {uuid: email_uuid, client_name: clientname},
      },
    };

    this.dialog.open(PCESModalComponent, dialogConfig);
  }  
}
